import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdAddAPhoto, MdCameraAlt, MdDelete, MdSave, MdStopCircle } from "react-icons/md";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ConfirmDeleteDialog, Loader, ScrollToTop } from "../../../components";

const TambahDaftarKunjungan = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const [sourceType, setSourceType] = useState("");
  const [entryPermohonan, setEntryPermohonan] = useState("");
  const [admin, setAdmin] = useState("");
  const [validasiDataVerifikator, setValidasiDataVerifikator] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);
  const [openOption, setOpenOption] = useState(false);
  let [pageOption, setPageOption] = useState(0);
  const [limitOption] = useState(10);
  const [pagesOption, setPagesOption] = useState(0);
  const [queryOption, setQueryOption] = useState("");
  const [searchTermOption, setSearchTermOption] = useState("");
  const [histories, setHistories] = useState([]);
  const [fotoKunjungan, setFotoKunjungan] = useState([]);
  const [previewKunjungan, setPreviewKunjungan] = useState([]);
  const [alasanKolektor, setAlasanKolektor] = useState("");
  const [tanggalKunjungan] = useState(new Date());
  const [cameraActive, setCameraActive] = useState(false);
  const [cameraError, setCameraError] = useState("");
  const [currentLocation, setCurrentLocation] = useState(null);
  const [deleteFotoIndex, setDeleteFotoIndex] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getOptions();
  }, [pageOption, searchTermOption]);

  useEffect(() => {
    return () => {
      stopCamera(false);
    };
  }, []);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const getOptions = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/daftarKunjunganOptionsPagination?search_query=${encodeURIComponent(searchTermOption)}&page=${pageOption}&limit=${limitOption}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQueryOption(searchTermOption);
      setOptions(response.data.options);
      setPageOption(response.data.page);
      setPagesOption(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data pilihan daftar kunjungan.");
    }
    setLoading(false);
  };

  const formatSourceType = (value) => {
    if (value === "ENTRY PERMOHONAN") return "DAFTAR PERMOHONAN";
    if (value === "ADMIN VERIFIKATOR") return "VALIDASI DATA VERIFIKATOR";
    return value || "-";
  };

  const getHistories = async (pickedSourceType, pickedEntryPermohonan, pickedAdmin, pickedValidasiDataVerifikator) => {
    try {
      const response = await axios.post(`${tempUrl}/daftarKunjunganHistories`, {
        sourceType: pickedSourceType,
        entryPermohonan: pickedEntryPermohonan,
        admin: pickedAdmin,
        validasiDataVerifikator: pickedValidasiDataVerifikator,
        id: user._id,
        token: user.token,
      });
      setHistories(response.data);
      return response.data;
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil riwayat daftar kunjungan.");
      return [];
    }
  };

  const optionHandler = async (pickedOption) => {
    const pickedEntryPermohonan =
      pickedOption.sourceType === "ENTRY PERMOHONAN"
        ? pickedOption.entryPermohonanId || pickedOption.entryPermohonan?._id || pickedOption.entryPermohonan || pickedOption._id?.replace("ENTRY_PERMOHONAN-", "")
        : "";
    const pickedAdmin = pickedOption.sourceType === "ADMIN" ? pickedOption.admin?._id : "";
    const pickedValidasiDataVerifikator =
      pickedOption.sourceType === "ADMIN VERIFIKATOR" ? pickedOption.validasiDataVerifikator?._id : "";

    setSelectedOption(pickedOption);
    setSourceType(pickedOption.sourceType);
    setEntryPermohonan(pickedEntryPermohonan);
    setAdmin(pickedAdmin);
    setValidasiDataVerifikator(pickedValidasiDataVerifikator);
    setHistories([]);
    await getHistories(pickedOption.sourceType, pickedEntryPermohonan, pickedAdmin, pickedValidasiDataVerifikator);
    setOpenOption(false);
  };

  const handleChangeOption = (e, p) => {
    setPageOption(p - 1);
  };

  const searchDataOption = (event) => {
    event.preventDefault();
    setPageOption(0);
    setSearchTermOption(queryOption);
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Browser tidak mendukung akses lokasi."));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            capturedAt: new Date().toISOString(),
          });
        },
        () => reject(new Error("Lokasi/GPS wajib aktif sebelum membuka kamera.")),
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        },
      );
    });
  };

  const waitForVideoElement = () => {
    return new Promise((resolve) => {
      const findVideo = () => {
        if (videoRef.current) {
          resolve(videoRef.current);
          return;
        }

        setTimeout(findVideo, 30);
      };

      findVideo();
    });
  };

  const playCameraStream = async (stream) => {
    const video = await waitForVideoElement();
    video.srcObject = stream;

    try {
      await video.play();
    } catch (err) {
      const isInterruptedPlay =
        err.name === "AbortError" ||
        err.message?.includes("interrupted by a new load request");

      if (!isInterruptedPlay) {
        throw err;
      }

      setTimeout(() => {
        if (video.srcObject === stream) {
          video.play().catch(() => {});
        }
      }, 120);
    }
  };

  const startCamera = async () => {
    try {
      stopCamera(false);
      setCameraError("");

      const location = await getCurrentLocation();
      setCurrentLocation(location);

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setCameraError("Browser tidak mendukung akses kamera.");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
        },
        audio: false,
      });

      streamRef.current = stream;
      await playCameraStream(stream);
      setCameraActive(true);
    } catch (err) {
      setCameraError(err.message || "Kamera tidak bisa dibuka. Pastikan izin kamera dan lokasi diberikan.");
      console.log(err);
    }
  };

  const stopCamera = (updateState = true) => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    if (updateState) {
      setCameraActive(false);
      setCurrentLocation(null);
    }
  };

  const capturePhoto = async () => {
    if (!videoRef.current || !canvasRef.current) {
      return;
    }

    let latestLocation = currentLocation;

    try {
      latestLocation = await getCurrentLocation();
      setCurrentLocation(latestLocation);
    } catch (err) {
      setCameraError("Lokasi/GPS wajib aktif sebelum mengambil foto.");
      return;
    }

    const video = videoRef.current;
    const canvas = canvasRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);

    canvas.toBlob(
      (blob) => {
        const capturedFile = new File([blob], `foto-kunjungan-${Date.now()}.jpg`, {
          type: "image/jpeg",
        });

        setFotoKunjungan((prevFiles) => [
          ...prevFiles,
          {
            file: capturedFile,
            latitude: latestLocation.latitude,
            longitude: latestLocation.longitude,
            accuracy: latestLocation.accuracy,
            capturedAt: latestLocation.capturedAt,
          },
        ]);
        setPreviewKunjungan((prevPreviews) => [...prevPreviews, URL.createObjectURL(capturedFile)]);
        setCameraError("");
      },
      "image/jpeg",
      0.9,
    );
  };

  const uploadFotoGroup = async (files) => {
    const uploadedImageUrls = await Promise.all(
      files.map(async (selectedPhoto) => {
        const selectedFile = selectedPhoto.file || selectedPhoto;
        const storageRef = firebase.storage().ref();
        const fileRef = storageRef.child(
          `${Date.now()}-${Math.floor(Math.random() * 1000 + 1)}-${selectedFile.name}`,
        );
        const snapshot = await fileRef.put(selectedFile);
        const url = await snapshot.ref.getDownloadURL();

        return {
          url,
          latitude: selectedPhoto.latitude,
          longitude: selectedPhoto.longitude,
          accuracy: selectedPhoto.accuracy,
          capturedAt: selectedPhoto.capturedAt,
        };
      }),
    );

    return uploadedImageUrls;
  };

  const hapusFotoBaru = () => {
    if (deleteFotoIndex == null) {
      return;
    }

    setFotoKunjungan(fotoKunjungan.filter((item, i) => i !== deleteFotoIndex));
    setPreviewKunjungan(previewKunjungan.filter((item, i) => i !== deleteFotoIndex));
    setDeleteFotoIndex(null);
  };

  const formatDateInput = (dateValue) => {
    const date = new Date(dateValue);
    return `${date.getFullYear()}-${(date.getMonth() + 1).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}-${date.getDate().toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}`;
  };

  const getKolektorLabel = () => {
    if ((user.tipeUser === "KOLEKTOR" || user.tipeUser === "EKS") && user.kodeKolektor?.kodeKolektor) {
      return `${user.kodeKolektor.kodeKolektor} - ${user.kodeKolektor.namaKolektor}`;
    }

    return user.kodeKolektor?.namaKolektor || user.username || "-";
  };

  const formatDisplayDate = (dateValue) => {
    if (!dateValue) {
      return "-";
    }

    return new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(dateValue));
  };

  const saveDaftarKunjungan = async (event) => {
    event.preventDefault();

    if (!sourceType || (!entryPermohonan && !admin && !validasiDataVerifikator) || !alasanKolektor) {
      setError("Pilihan data dan alasan kolektor wajib diisi.");
      return;
    }

    if (fotoKunjungan.length === 0) {
      setError("Foto kunjungan wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      const fotoKunjunganUploaded = await uploadFotoGroup(fotoKunjungan);

      await axios.post(`${tempUrl}/saveDaftarKunjungan`, {
        sourceType,
        entryPermohonan,
        admin,
        validasiDataVerifikator,
        fotoKunjungan: fotoKunjunganUploaded,
        alasanKolektor,
        tanggalKunjungan: formatDateInput(tanggalKunjungan),
        id: user._id,
        token: user.token,
      });
      navigate("/daftarKunjungan");
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal menyimpan daftar kunjungan.");
      setLoading(false);
    }
  };

  const renderDialogOption = () => {
    return (
      <Dialog open={openOption} onClose={() => setOpenOption(false)} maxWidth="md" fullWidth>
        <DialogTitle>{`Pilih Data Daftar Kunjungan`}</DialogTitle>
        <DialogContent>
          <Form onSubmit={searchDataOption}>
            <div className="search-row mt-0 mb-3">
              <Form.Control
                value={queryOption}
                placeholder="Cari nama pemohon, no jual, nopol, alamat, atau sumber..."
                onChange={(e) => setQueryOption(e.target.value)}
              />
              <Button type="submit">Cari</Button>
            </div>
          </Form>
          <TableContainer component={Paper}>
            <Table aria-label="pilih data daftar kunjungan">
              <TableHead>
                <TableRow>
                  <TableCell>Nama Pemohon</TableCell>
                  <TableCell>No Jual</TableCell>
                  <TableCell>Nopol</TableCell>
                  <TableCell>Alamat</TableCell>
                  <TableCell>Sumber</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {options.map((item) => (
                  <TableRow
                    key={item._id}
                    className="row-clickable"
                    onClick={() => optionHandler(item)}
                  >
                    <TableCell>{item.optionNamaPemohon || "-"}</TableCell>
                    <TableCell>{item.optionNoJual || "-"}</TableCell>
                    <TableCell>{item.optionNopol || "-"}</TableCell>
                    <TableCell>{item.optionAlamat || "-"}</TableCell>
                    <TableCell>{formatSourceType(item.sourceType)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search-row">
            <Pagination
              count={pagesOption}
              page={pageOption + 1}
              onChange={handleChangeOption}
              color="primary"
              size={screenSize <= 600 ? "small" : "medium"}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-back" variant="outline-secondary" type="button" onClick={() => setOpenOption(false)}>
            {"< Kembali"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderHistoryTable = () => {
    if (!selectedOption) {
      return null;
    }

    return (
      <section className="section-panel mt-3">
        <h2 className="h6 fw-bold mb-3">Riwayat Daftar Kunjungan</h2>
        {histories.length === 0 ? (
          <div className="text-muted">Belum ada riwayat kunjungan.</div>
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label="riwayat daftar kunjungan">
              <TableHead>
                <TableRow>
                  <TableCell>Tanggal Kunjungan</TableCell>
                  <TableCell>Alasan Kolektor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {histories.map((history) => (
                  <TableRow key={history._id}>
                    <TableCell>{formatDisplayDate(history.tanggalKunjungan)}</TableCell>
                    <TableCell>{history.alasanKolektor || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </section>
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Tambah Daftar Kunjungan</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={saveDaftarKunjungan}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Data</Form.Label>
                <Form.Control
                  value={selectedOption?.optionNamaPemohon || ""}
                  placeholder="PILIH DATA"
                  readOnly
                  onClick={() => setOpenOption(true)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nama</Form.Label>
                <Form.Control value={selectedOption?.optionNamaPemohon || ""} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Alamat</Form.Label>
                <Form.Control as="textarea" rows={3} value={selectedOption?.optionAlamat || ""} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>No Jual</Form.Label>
                <Form.Control value={selectedOption?.optionNoJual || ""} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nopol</Form.Label>
                <Form.Control value={selectedOption?.optionNopol || ""} disabled readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Sumber</Form.Label>
                <Form.Control value={formatSourceType(sourceType)} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Kolektor</Form.Label>
                <Form.Control value={getKolektorLabel()} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Tanggal Kunjungan</Form.Label>
                <Form.Control type="date" value={formatDateInput(tanggalKunjungan)} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Alasan Kolektor</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={alasanKolektor}
                  onChange={(e) => setAlasanKolektor(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {renderHistoryTable()}

          <section className="section-panel mt-3">
            <h2 className="h6 fw-bold mb-3">Foto Kunjungan</h2>
            {cameraError && <Alert variant="warning">{cameraError}</Alert>}
            <div className="camera-box">
              <video
                ref={videoRef}
                playsInline
                muted
                className="camera-preview"
                style={{ display: cameraActive ? "block" : "none" }}
              />
              <canvas ref={canvasRef} style={{ display: "none" }} />
            </div>
            <div className="form-actions mb-3">
              <Button className="btn-icon" type="button" onClick={startCamera} disabled={cameraActive}>
                <MdCameraAlt /> Buka Kamera
              </Button>
              <Button className="btn-icon" type="button" variant="success" onClick={capturePhoto} disabled={!cameraActive}>
                <MdAddAPhoto /> Ambil Foto
              </Button>
              <Button className="btn-icon" type="button" variant="outline-secondary" onClick={stopCamera} disabled={!cameraActive}>
                <MdStopCircle /> Tutup Kamera
              </Button>
            </div>
            {previewKunjungan.length > 0 && <div className="detail-label mb-2">Foto Baru</div>}
            <div className="photo-grid">
              {previewKunjungan.map((img, i) => (
                <div className="photo-card old-photo-card" key={`foto-kunjungan-new-${i}`}>
                  <button type="button">
                    <img src={img} alt={`Foto Kunjungan baru ${i + 1}`} />
                    <span>No. {i + 1}</span>
                  </button>
                  <Button className="photo-delete-btn" size="sm" variant="outline-danger" type="button" onClick={() => setDeleteFotoIndex(i)}>
                    <MdDelete /> Hapus
                  </Button>
                </div>
              ))}
            </div>
          </section>

          <div className="form-actions mt-3">
            <Button className="btn-back" type="button" variant="outline-secondary" onClick={() => navigate("/daftarKunjungan")}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
      {renderDialogOption()}
      <ConfirmDeleteDialog
        show={deleteFotoIndex != null}
        message="Yakin ingin menghapus foto ini?"
        onCancel={() => setDeleteFotoIndex(null)}
        onConfirm={hapusFotoBaru}
      />
    </div>
  );
};

export default TambahDaftarKunjungan;
